import styled from 'styled-components';
import Email from '@material-ui/icons/Email';

import { commonIconStyles } from './styles';

export default styled(Email)`${commonIconStyles}`;
